import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";

const url = "basic_data/get";

const state = {
    basicData: [],
    commonOpt: [
        { id: 2, name: "Missing" },
        { id: 1, name: "Not done" },
        { id: 3, name: "done" },
    ],
    commonResultOpt: [
        { id: 1, name: "Negative" },
        { id: 2, name: "Positive" },
        { id: 3, name: "Missing" },
    ],
    InitialOpt: [{ id: 1, text: "M" }],
    relationOpt: [
        { id: 1, text: "Household Contact" },
        // { id: 2, text: "Non Household" },
        { id: 3, text: "Close Contact" },
        { id: 4, text: "Other Contact" },
    ],
};
const getters = {
    referralTypeOpt(state) {
        return state.basicData.referral_type;
    },
    referralFromOpt(state) {
        return state.basicData.referral_from;
    },
    symptonOpt(state) {
        return state.basicData.sympton;
    },
    riskFactorOpt(state) {
        return state.basicData.risk_factor;
    },
    conclusionsOpt(state) {
        return state.basicData.conclusions;
    },
    caseFoundatOpt(state) {
        return state.basicData.case_found_at;
    },
    hivResult(state) {
        return state.basicData.hiv;
    },
    sputumResult(state) {
        return state.basicData.sputum;
    },
    cultureResult(state) {
        return state.basicData.culture;
    },
    cxrResult(state) {
        return state.basicData.cxr;
    },
    geneResult(state) {
        return state.basicData.gene_xpert;
    },
    dstResult(state) {
        return state.basicData.dst;
    },
};

const mutations = {
    SET_BASIC_DATA(state, payload) {
        state.basicData = payload.data;
    },
};

const actions = {
    async getBasicData({ commit }) {
        const response = await Request.get_data(url);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess())
            commit("SET_BASIC_DATA", response);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};